<template>
  <div>
    <div class="row">
      <div class="col s12 lightgrey">
        <div class="col s12 m10 l8 offset-m1 offset-l2">
          <h2 class="header">{{$t("cv.resume")}}</h2>
          <div class="card">
            <img :src="'static/img/'+$t('cv.file')" class="col s12 m10 l8 offset-m1 offset-l2" alt="cv" id="cv"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Cv'
}
</script>



// WEBPACK FOOTER //
// src/components/Cv.vue